import { useEffect, useState, useContext, useMemo } from "react"
import logo from '../img/logo.png'
import New from '../img/new.png'

import light from '../img/light.png'
import dark from '../img/dark.png'

import light_s from '../img/light-s.png'
import dark_s from '../img/dark-s.png'
import qrLogo from '../img/qr-logo-black.png'
import { Context,Hooks,XtLocale,Config,Storage,Util } from "@xt/xtbase";
const {XtContext,XtAuth} = Context;
const {useTranslation} = Hooks;
import styles from "../index.module.less";
const {getUrl,getQuery} = Util;
import QrCode from "@xt/QrCode";
import Notice from "./notice";
import IconXiala01 from "../img/icon/xiala-01";
import IconRenzheng from "../img/icon/renzheng";
import IconGeren from "../img/icon/geren";
import IconMore from "../img/icon/more";
import moreExchange from "../img/more/exchange.png";
import moreAcademy from "../img/more/academy.png";
import moreReferral from "../img/more/referral.png";
import moreSchedule from "../img/more/schedule.png";
import moreStarter from "../img/more/starter.png";
import moreAffiliate from "../img/more/affiliate.png";
import otcDebit from "../img/otc/debit.png";
import tradeSpot from "../img/trade/spot.png";
import tradeMargin from "../img/trade/margin.png";
import derivativesOverview from "../img/derivatives/overview.png";
import derivativesUsdt from "../img/derivatives/usdt.png";
import derivativesCoin from "../img/derivatives/coin.png";
import derivativesPredict from "../img/derivatives/predict.png";
import derivativesGrid from "../img/derivatives/grid.png";
import derivativesMock from "../img/derivatives/mock.png";
import fire from "../img/fire.png";
import copyTrading from "../img/copy/trading.png";
import copyRecruiting from "../img/copy/recruiting.png";
import financeIndex from "../img/finance/index.png";
import listingVote from "../img/listing/vote.png";
import listingIndex from "../img/listing/index.png";
import walletOverview from "../img/wallet/overview.png";
import walletSpot from "../img/wallet/spot.png";
import walletMargin from "../img/wallet/margin.png";
import walletFinance from "../img/wallet/finance.png";
import IconWalletOverview from "../img/icon/walletoverview";
import IconWalletSpot from "../img/icon/walletspot";
import IconWalletMargin from "../img/icon/walletmargin";
import IconWalletFinance from "../img/icon/walletfinance";
import IconOrderFiat from "../img/icon/orderfiat";
import { resolveCfdSymbol } from "../utils/getCfdSymbol";
import { useNavStore } from "../NavStoreContext";
import { observer } from "mobx-react-lite";

function NavbarPc(props) {
  const [appState] = useContext(XtContext);
  const { fund } = useNavStore();
  const {lang, theme, currency, userInfo, authInfo, loginStatus} = appState;
  const t = useTranslation()
  const [isShowMask, setIsShowMask] = useState(false)
  const [fixedStyle, setFixedStyle] = useState(false)
  const langAry = XtLocale.localeList;
  const langCode = XtLocale.intl.code;
  const [spotMarket, setSpotMarket] = useState("btc_usdt");
  const [leverMarket, setLeverMarket] = useState("btc_usdt");
  const [cfdMarket, setCfdMarket] = useState("btc_usdt_cfd");
  const [etfMarket, setEtfMarket] = useState("btc3l_usdt");
  const [etfIndexMarket, setEtfIndexMarket] = useState("index-btc_usdt");

  const [loginQuery, setLoginQuery] = useState("");
  const [activeNav, setActiveNav] = useState("");
  const recommendedCurrencyKey = useMemo(() => {
    return (fund?.recommendedCurrencyList || [])
      .map((item) => `${item?.currency || ""}:${(item?.plates || []).join(",")}`)
      .join("|");
  }, [fund?.recommendedCurrencyList, fund?.recommendedCurrencyListMd5]);
  
  const handleScrollNav = (props) => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollTop) {
      setFixedStyle(true);
    } else {
      setFixedStyle(false);
    }
  }

  useEffect(()=>{
    setSpotMarket(Storage.get("market") || spotMarket);
    setLeverMarket(Storage.get("leverMarket") || leverMarket);

    resolveCfdSymbol({
      fiatCurrencyIds: userInfo?.fiatCurrencyIds,
      loginStatus,
    }).then((symbol) => {
      setCfdMarket(symbol);
    });

    setEtfMarket(Storage.get("etfMarket") || etfMarket);
    setEtfIndexMarket(Storage.get("etfIndexMarket") || etfIndexMarket);
    const ref = getQuery("ref");
    setLoginQuery("?backurl="+encodeURIComponent(location.href)+(ref?"&ref="+ref:""));
    var pathname = location.pathname;
    if(pathname.startsWith("/"+XtLocale.intl.locale))
    {
      pathname = pathname.substring(("/"+XtLocale.intl.locale).length);
    }
    if(/^\/(LaunchPad|labs|referral|affiliate|schedule|activity\/coupon)($|[\/\?#])/.test(pathname))
      setActiveNav("more");
    else if(/^\/(market)($|[\/\?#])/.test(pathname))
      setActiveNav("market");
    else if(/^\/(trade|tradePro|margin|marginPro|cfd|futures)($|[\/\?#])/.test(pathname))
      setActiveNav("trade");
    else if(/^\/(etf|etfPro|contract)($|[\/\?#])/.test(pathname))
      setActiveNav("etf");
    else if(/^\/(otc|credit\/debitCard)($|[\/\?#])/.test(pathname))
      setActiveNav("otc");
    else if(/^\/finance($|[\/\?#])/.test(pathname))
      setActiveNav("finance");
    else if(/^\/listing($|[\/\?#])/.test(pathname))
      setActiveNav("listing");
    else if(/^\/account($|[\/\?#])/.test(pathname))
      setActiveNav("account");
    else if(/^\/wallet($|[\/\?#])/.test(pathname))
      setActiveNav("wallet");
    else if(/^\/orders($|[\/\?#])/.test(pathname))
      setActiveNav("orders");
    else if(/^\/nft($|[\/\?#])/.test(pathname))
      setActiveNav("nft");
    else if(/^\/activity\/2022-world-cup-prediction-event($|[\/\?#])/.test(pathname))
      setActiveNav("worldcup");
    else if(/^\/activity\/5-years-anniversary($|[\/\?#])/.test(pathname))
      setActiveNav("fiveyears");
    else if(pathname.startsWith("/strategy/futures/grid/"))
    {
      setActiveNav("strategy");
    }
    if(props.mode == "fixed")
      window.addEventListener("scroll", handleScrollNav, true);

    return ()=> {
      if(props.mode == "fixed")
        window.removeEventListener('scroll', handleScrollNav, true);
    }
  }, [userInfo?.fiatCurrencyIds, loginStatus, recommendedCurrencyKey])

  const handleMouseleaveFn = () => {
    //setIsShowMask(false);
  }

  const handleMouseenterFn = () => {
    //setIsShowMask(true);
  }

  const handleMouseleaveBar = () => {
    if(props.mode == "fixed")
      handleScrollNav();
  }

  const handleMouseenterBar = () => {
    if(props.mode == "fixed")
      setFixedStyle(true);
  }

  return (
    <div className={`${styles['app-navbar-pc']} ${fixedStyle && !isShowMask ? styles.maskBar : ''}`} onMouseLeave={handleMouseleaveBar} onMouseEnter={handleMouseenterBar}>
      {isShowMask && false && (
        <div className={styles['navbar-blur-mask']}></div>
      )}
      <div>
        <a href={getUrl("/")} style={{paddingLeft: 0}}>
          <img style={{height: '42px'}} src={logo} />
        </a>

        <div className={`${styles.iMore} ${styles.iDrop}`} onMouseLeave={handleMouseleaveFn} onMouseEnter={handleMouseenterFn}>
          <a tabIndex="0" className={activeNav == "more" ? styles.atv : ""}>
            <div className={styles['more-icon']}>
              <IconMore />
            </div>
            <IconXiala01 className={`${styles['iconxiala-01']}`}/>
          </a>
          <div className={styles['base-top-mask']}>
            <div className={`${styles['base-top-itemlist']} ${styles['grid-row-three']}`}>
              <a href={getUrl("/futures/contract/"+cfdMarket)}>
                <div className={styles.iIco}>
                  <img src={moreExchange} className="iconImg"/>
                </div>
                <div className={styles.iLab}>
                  <b>Exchange</b>
                  <div>{t("header.digitalPlatform")}</div>
                </div>
              </a>
              {/* <a href={getUrl("/launchpad")}>
                <div className={styles.iIco}>
                  <img src={moreStarter} className="iconImg"/>
                </div>
                <div className={styles.iLab}>
                  <b>Sigma Launchpad</b>
                  <div>{t("header.tokenPlatform")}</div>
                </div>
              </a> */}
              <a href={getUrl("/academy")}>
                <div className={styles.iIco}>
                  <img src={moreAcademy} className="iconImg"/>
                </div>
                <div className={styles.iLab}>
                  <b>Academy</b>
                  <div>{t("header.academyTip")}</div>
                </div>
              </a>
              <a href={getUrl("/referral")}>
                <div className={styles.iIco}>
                  <img src={moreReferral} className="iconImg"/>
                </div>
                <div className={styles.iLab}>
                  <b>{t("header.superPartner")}</b>
                  <div>{t("header.rebateRate")}</div>
                </div>
              </a>
              {/* <a href={getUrl("/schedule")}>
                <div className={styles.iIco}>
                  <img src={moreSchedule} className="iconImg"/>
                </div>
                <div className={styles.iLab}>
                  <b>{t("header.schedule")}</b>
                  <div>{t("header.lastestInfo")}</div>
                </div>
              </a> */}
              <a href={getUrl("/affiliate")}>
                <div className={styles.iIco}>
                  <img src={moreAffiliate} className="iconImg"/>
                </div>
                <div className={styles.iLab}>
                  <b>{t("header.affiliate")}</b>
                  <div>{t("header.affiliateTip")}</div>
                </div>
              </a>
            </div>
            <div className={styles['base-top-desc']}>
              <div className={styles.tit}>{t("header.Learn")}</div>
              <div className={styles.desc}>{t("header.Building")}</div>
            </div>
          </div>
        </div>

        <div className={styles.iDrop} onMouseLeave={handleMouseleaveFn} onMouseEnter={handleMouseenterFn}>
          <a tabIndex="0" className={activeNav == "otc" ? styles.atv : ""}>
            <span>{t("header.buyCrypto")}</span>
            <IconXiala01 className={`${styles['iconxiala-01']}`}/>
          </a>
          <div className={`${styles['base-top-mask']} ${styles['noHeight']}`}>
            <div className={`${styles['base-top-itemlist-flex']} ${styles['base-iconlist']}`}>
              <a href={getUrl("/credit/debitCard")}>
                <div className={styles.iIco}>
                  <img src={otcDebit} className="iconImg"/>
                </div>
                <div className={styles['base-line']}></div>
                <div className={styles.iLab}>
                  <b>{t("header.tipThird")}</b>
                  <div>{t("header.navTipThird")}</div>
                </div>
              </a>
            </div>
          </div>
        </div>

        <a className={activeNav == "market" ? styles.atv : ""} href={getUrl("/market")}>{t("header.markets")}</a>

        <div className={styles.iDrop} onMouseLeave={handleMouseleaveFn} onMouseEnter={handleMouseenterFn}>
          <a className={activeNav == "trade" ? styles.atv : ""}>
            <span>{t("header.trading")}</span>
            <IconXiala01 className={`${styles['iconxiala-01']}`}/>
          </a>
          <div className={styles['base-top-mask']}>
            <div className={`${styles['base-top-itemlist']} ${styles['base-iconlist']}`}>
              <a href={getUrl("/futures/contract/"+cfdMarket)}>
                <div className={styles.iIco}>
                  <img src={tradeSpot} className="iconImg"/>
                </div>
                <div className={styles['base-line']}></div>
                <div className={styles.iLab}>
                  <b>{t("header.spotTrading")}</b>
                  <div>{t("header.navTipSpot")}</div>
                </div>
              </a>
              {/*<ul>*/}
              {/*  <li><a href={getUrl("/trade/"+spotMarket)}>• {t("header.standard")}</a></li>*/}
              {/*  <li><a href={getUrl("/tradePro/"+spotMarket)}>• {t("header.pro")}</a></li>*/}
              {/*</ul>*/}
              <a href={getUrl("/futures/contract/"+cfdMarket)}>
                <div className={styles.iIco}>
                  <img src={tradeMargin} className="iconImg"/>
                </div>
                <div className={styles['base-line']}></div>
                <div className={styles.iLab}>
                  <b>{t("header.cfdTrading")}</b>
                  <div>{t("header.navTipCfd")}</div>
                </div>
              </a>
              {/* {authInfo && authInfo.country && authInfo.country.code != "971" ? <a href={getUrl("/trade/" + leverMarket + "?type=margin")}>
                <div className={styles.iIco}>
                  <img src={tradeMargin} className="iconImg"/>
                </div>
                <div className={styles['base-line']}></div>
                <div className={styles.iLab}>
                  <b>{t("header.marginTrading")}</b>
                  <div>{t("header.navTipMargin")}</div>
                </div>
              </a> : null} */}
            </div>
            <div className={styles['base-top-desc']}>
              <div className={styles.tit}>{t("header.Crypto")}</div>
              <div className={styles.desc}>{t("header.BuyExchange")}</div>
              {/* <div className="topage">
                <router-link to="/tradePro">{t("header.SeeProducts")}<img src="../img/topage.png" /></router-link>
              </div> */}
            </div>
          </div>
        </div>

        {/* <div
          className={`${styles.iDrop} ${styles.ds}`}
          onMouseLeave={handleMouseleaveFn}
          onMouseEnter={handleMouseenterFn}
        >
          <a tabIndex="0" className={activeNav == "finance" ? styles.atv : ""}>
            <span>{t("header.finance")}</span>
            <IconXiala01 className={`${styles['iconxiala-01']}`}/>
          </a>
          <div className={`${styles['base-top-mask']} ${styles['noHeight']}`}>
            <div className={`${styles['base-top-itemlist-flex']} ${styles['base-iconlist']} ${styles['custom-width']}`}>
              <a href={getUrl("/finance/simple-earn")}>
                <div className={styles.iIco}>
                  <img src={financeIndex} className="iconImg"/>
                </div>
                <div className={styles['base-line']}></div>
                <div className={styles.iLab}>
                  <b>{t("header.FinanceSimpleEarn")}</b>
                  <div>{t("header.FinanceSimpleEarnDesc")}</div>
                </div>
              </a>
              <ul>
                <li><a href={getUrl("/finance/savings")}>• {t("header.FinanceSavings")}</a></li>
                <li><a href={getUrl("/finance/staking")}>• {t("header.FinanceStaking")}</a></li>
              </ul>
            </div>
          </div>
        </div> */}

        {/* <a className={activeNav == "listing" ? styles.atv : ""} href={getUrl("/listing")}>{t("header.list")}</a> */}

      </div>
      <div>
          <XtAuth renderLogin={(userInfo)=>{return <>
          <div className={`${styles.iDrop} ${styles.iNew}`}>
            <a href={getUrl("/wallet/account")} className={activeNav == "wallet" ? styles.atv : ""}>
              <span>{t("header.asset")}</span>
              <IconXiala01 className={`${styles['iconxiala-01']}`}/>
            </a>
            <div>
              <a href={getUrl("/wallet/account/overview")}>
                <img src={walletOverview} />
                <span>{ t("header.overview") }</span>
              </a>
              <a href={getUrl("/wallet/account/spot")}>
                <img src={walletSpot} />
                <span>{ t("header.SpotAccount") }</span>
              </a>
              {/* {authInfo && authInfo.country && authInfo.country.code != "971" ? <a href={getUrl("/wallet/account/margin")}>
                <img src={walletMargin} />
                <span>{ t("header.marginAccount") }</span>
              </a> : null} */}
              <a href={getUrl("/wallet/account/finance")}>
                <img src={walletFinance} />
                <span>{ t("header.FinanceAccount") }</span>
              </a>
            </div>
          </div>
          <div className={`${styles.iDrop} ${styles.iNew}`}>
            <a href={getUrl("/orders")} className={activeNav == "orders" ? styles.atv : ""}>
              <span>{t("header.order")}</span>
              <IconXiala01 className={`${styles['iconxiala-01']}`}/>
            </a>
            <div>
              <a href={getUrl("/orders/spot/openorder")}>
                <img src={walletSpot} />
                <span>{ t("header.spotOrder") }</span>
              </a>
              {/* {authInfo && authInfo.country && authInfo.country.code != "971" ? <a href={getUrl("/orders/margin/openorder")}>
                <img src={walletMargin} />
                <span>{ t("header.leverOrder") }</span>
              </a> : null} */}
              <a href={getUrl("/orders/finance/myproduct")}>
                <img src={walletFinance} />
                <span>{ t("header.financeOrder") }</span>
              </a>
            </div>
          </div>
          <div className={`${styles.iDrop} ${styles.iUser} ${styles.isRel}`}>
            <a href={getUrl("/account/overview")} className={activeNav == "account" ? styles.atv : ""}>
              <IconGeren style={{"width": "20px","height": "20px"}}/>
            </a>
            <div>
              <p className={styles.navUserName}>{userInfo.secretUserName}</p>
              <div>
                <a className={userInfo.authLevel ? styles.atv : ""}>
                  <IconRenzheng />
                  <span>{ t(userInfo.authLevel ? "header.verified" : "header.unverified") }</span>
                </a>
              </div>
              <a href={getUrl("/account/overview")}>
                <span>{ t("header.overview") }</span>
              </a>
              <a href={getUrl("/account/index")}>
                <span>{ t("header.securityCenter") }</span>
              </a>
              <a href={getUrl("/account/personal")}>
                <span>{ t("header.realName") }</span>
              </a>
              <a href={getUrl("/referral")}>
                <span>{ t("header.superPartner") }</span>
              </a>
              <a href={getUrl("/account/api")}>
                <span>{ t("header.apiMgmt") }</span>
              </a>
              <a onClick={()=>{props.doLogout()}}>
                <span>{ t("header.safelyLogout") }</span>
              </a>
            </div>
          </div>
          <Notice />
        </>}} renderNotLogin={()=>{return <>
            <a href={getUrl("/accounts/login"+loginQuery)} style={{paddingRight:"20px"}}>{t("header.login")}</a>
            <a href={getUrl("/accounts/register"+loginQuery)} className={styles.iRegisterBtn}>{t("header.signUp")}</a>
          </>
          }}></XtAuth>

          <div className={`${styles.iDrop} ${styles.isRel} ${styles.iAppDl} ${styles.isDownload}`}>
            <a tabIndex="0">
              <span>{ t("header.download") }</span>
            </a>
            <div>
            <div className={styles.content}>
              <QrCode size="160" logo={qrLogo} isShowLogo={true} margin="12"/>
              <div className={styles["download-text"]}>{ t("header.scanDlApp") }</div>
            </div>
            </div>
          </div>

          <div className={`${styles.iDrop} ${styles.isRel} ${styles.iLang}`}>
            <a tabIndex="0" className={styles['iDrop-link']}>
              <span>{langAry.find(item=>lang === item.key).lab + "/" + (Config.assistConfig.find(item=>currency === item.key) || {name:"USD"}).name}</span>
              <IconXiala01 className={`${styles['iconxiala-01']}`}/>
            </a>
            <div>
              <div>
                <span>{t("header.lang")}</span>
                {
                  langAry.map((item)=>(
                    <a
                      key={item.key}
                      tabIndex="0"
                      onClick={()=>props.onLocale(item)}
                      className={`${lang === item.key ? styles.atv : ''}`}
                      >
                      {item.lab}
                    </a>
                  ))
                }
              </div>
              <div>
                <span>{ t("header.currency") }</span>
                {
                  Config.assistConfig.map((item)=>(
                    <a
                      key={item.key}
                      tabIndex="0"
                      onClick={()=>props.onAssist(item)}
                      className={`${currency === item.key ? styles.atv : ''}`}
                      >
                      {item.name}
                    </a>
                  ))
                }
              </div>
            </div>
          </div>
          {props.showTheme ? <div className={`${styles['base-theme-icon']}`} style={{"margin":"0 5px"}} onClick={props.onTheme}>
            {
              theme === 'light' && (
                <>
                  <i style={{backgroundImage:`url(${dark})`}}></i>
                  <i style={{backgroundImage:`url(${dark_s})`}}></i>
                </>
              )
            }

            {
              theme === 'dark' && (
                <>
                  <i style={{backgroundImage:`url(${light})`}}></i>
                  <i style={{backgroundImage:`url(${light_s})`}}></i>
                </>
              )
            }
          </div> : null}
        </div>
    </div>
  )
}
export default observer(NavbarPc);
